import React, { createContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { HEALTH_CHECK_OVERVIEW } from '../Constants/strings';

export const HealthCheckOverviewContext = createContext();

export const HealthCheckOverviewProvider = ({ children }) => {
  const [tableState, setTableState] = useState(() => {
    return Object.values(HEALTH_CHECK_OVERVIEW).reduce((acc, table) => {
      acc[table] = false;
      return acc;
    }, {});
  });

  const [expandAll, setExpandAll] = useState(false);
  const expandAllHandler = () => {
    const newExpandState = !expandAll;
    setExpandAll(newExpandState);
    setTableState((prevState) => {
      const newState = {};
      for (const key in prevState) {
        newState[key] = newExpandState;
      }
      return newState;
    });
  };

  const expandIndividual = (tableName) => {
    if (!Object.values(HEALTH_CHECK_OVERVIEW).includes(tableName)) return;
    setTableState((prev) => {
      const newState = {
        ...prev,
        [tableName]: !prev[tableName],
      };
      const checkAllExpandedState = Object.values(newState).every(
        (state) => state,
      );
      setExpandAll(checkAllExpandedState);
      return newState;
    });
  };

  const value = useMemo(
    () => ({
      allExpanded: expandAll,
      expandAllHandler,
      expandIndividual,
      accordionState: tableState,
    }),
    [expandAll, tableState],
  );
  return (
    <HealthCheckOverviewContext.Provider value={value}>
      {children}
    </HealthCheckOverviewContext.Provider>
  );
};

HealthCheckOverviewProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
